import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const useSourceOfFunds = (profileUuid) => {
  const middleman = useMiddleman();
  return useQuery(['sourceOfFunds', profileUuid], () => {
    return middleman.promiseGet(`/ql/crm/source-of-funds/${profileUuid}`).then(response => response.data);
  });
};

export const clientUseSourceOfFunds = (portfolioUuid) => {
  const middleman = useMiddleman();
  return useQuery(['clientSourceOfFunds', portfolioUuid], () => {
    return middleman.promiseGet(`/source-of-funds/show/${portfolioUuid}`).then(response => response.data);
  }, { enabled: !!portfolioUuid });
};
